import React from 'react'
import { Link } from 'react-router-dom'
import Footer_1 from '../../assets/images/svg/footer-two/footer-two-mail.svg';
import Footer_2 from '../../assets/images/footer-three/footer-three-patner-1.svg';
import Footer_3 from '../../assets/images/footer-three/footer-three-patner-2.svg';
import Footer_4 from '../../assets/images/footer-three/footer-three-patner-3.svg';
import footer_5 from '../../assets/images/footer-three/footer-three-patner-4.svg';
import footer_6 from '../../assets/images/Logo.svg';
import footer_7 from '../../assets/images/footer-three/address.svg';
import footer_8 from '../../assets/images/footer-three/mail.svg';
import footer_9 from '../../assets/images/svg/footer-two/footer-two-c-1.svg';
import footer_10 from '../../assets/images/svg/footer-two/footer-two-c-2.svg';
import footer_11 from '../../assets/images/svg/footer-two/footer-two-c-3.svg';
import footer_12 from '../../assets/images/svg/footer-two/footer-two-c-4.svg';
import footer_13 from '../../assets/images/svg/footer-two/footer-two-c-5.svg';
import footer_14 from '../../assets/images/footer-icon/footer-one-1.svg';
import footer_15 from '../../assets/images/footer-icon/footer-one-2.svg';
import footer_16 from '../../assets/images/footer-icon/footer-one-3.svg';
import footer_17 from '../../assets/images/footer-icon/footer-one-4.svg';
import footer_18 from '../../assets/images/footer-icon/footer-one-5.svg';
import footer_19 from '../../assets/images/footer-icon/footer-one-6.svg';
import footer_20 from '../../assets/images/footer-icon/footer-one-7.svg';
import footer_21 from '../../assets/images/footer-icon/footer-one-8.svg';
import footer_22 from '../../assets/images/footer-icon/footer-one-9.svg';
import footer_23 from '../../assets/images/footer-icon/footer-one-10.svg';
import footer_24 from '../../assets/images/svg/header/Insta.svg';
import footer_25 from '../../assets/images/svg/header/Fb.svg';
import footer_26 from '../../assets/images/svg/header/Twiter.svg';
import footer_27 from '../../assets/images/svg/header/Pintrest.svg';

const Footer3 = () => {
    return (
        <>
            <footer className="footer-section-three">
                <div className="container">
                    <div className="footer-newslatter-three row gutter-y-30">
                        <div className="col-lg-6">
                            <div
                                className="heading-box animate zoomIn wow"
                                data-wow-duration="1500ms"
                            >
                                <h2 className="heading-title">
                                    Subscribe &amp; get 20% off on your first project, Be with us
                                </h2>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div
                                className="newslatter-three animate zoomIn wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <form action="#">
                                    <div className="newslatter-form-group-three">
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            placeholder="enter your email"
                                            required=""
                                        />
                                        <button type="submit">
                                            <img
                                                src={Footer_1}
                                                alt="icon"
                                            />
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div
                                className="partner-three animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <ul>
                                    <li>
                                        <img
                                            src={Footer_2}
                                            alt="logo"
                                        />
                                    </li>
                                    <li>
                                        <img
                                            src={Footer_3}
                                            alt="logo"
                                        />
                                    </li>
                                    <li>
                                        <img
                                            src={Footer_4}
                                            alt="logo"
                                        />
                                    </li>
                                    <li>
                                        <img
                                            src={footer_5}
                                            alt="logo"
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="footer-about-three animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="footer-logo-three">
                                    <Link to="/">
                                        <img src={footer_6} alt="logo" />
                                    </Link>
                                </div>
                                <ul className="footer-about-list-three">
                                    <li>
                                        <img src={footer_7} alt="icon" />
                                        <p>Old Westbury 256, New York 11201, United States</p>
                                    </li>
                                    <li>
                                        <img src={footer_8} alt="icon" />
                                        <Link to="mailto:Uniqu@example.com">Uniqu@example.com</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="footer-widget-two animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <h4>Company</h4>
                                <ul className="footer-menu-two">
                                    <li>
                                        <img
                                            src={footer_9}
                                            alt="icon"
                                        />
                                        <Link to="/Services">Financial Analysis</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_10}
                                            alt="icon"
                                        />
                                        <Link to="/Services">Market Research</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_11}
                                            alt="icon"
                                        />
                                        <Link to="/Services">Competitive Analysis</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_12}
                                            alt="icon"
                                        />
                                        <Link to="/Services">Team Building</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_13}
                                            alt="icon"
                                        />
                                        <Link to="/Services">HR Management</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="footer-widget-two animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <h4>Services</h4>
                                <ul className="footer-menu-two">
                                    <li>
                                        <img
                                            src={footer_14}
                                            alt="icon"
                                        />
                                        <Link to="/ServiceDetails">Financial Analysis</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_15}
                                            alt="icon"
                                        />
                                        <Link to="/ServiceDetails">Work organization</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_16}
                                            alt="icon"
                                        />
                                        <Link to="/ServiceDetails">Digital Marketing</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_17}
                                            alt="icon"
                                        />
                                        <Link to="/ServiceDetails">Innovation space</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_18}
                                            alt="icon"
                                        />
                                        <Link to="/ServiceDetails">Risk Advisory</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="footer-widget-two animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="800ms"
                            >
                                <h4>Pages</h4>
                                <ul className="footer-menu-two">
                                    <li>
                                        <img
                                            src={footer_19}
                                            alt="icon"
                                        />
                                        <Link to="/Aboutus">About</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_20}
                                            alt="icon"
                                        />
                                        <Link to="/Careers">Career </Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_21}
                                            alt="icon"
                                        />
                                        <Link to="/Aboutus">Applications</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_22}
                                            alt="icon"
                                        />
                                        <Link to="/Contact">Contact Us</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_23}
                                            alt="icon"
                                        />
                                        <Link to="/Portfolio">Case Studies</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="footer-lower-two">
                                <p className="lead">
                                    © Copyright@&nbsp;Uniqo&nbsp;All rights reserved
                                </p>
                                <ul>
                                    <li>
                                        <Link to="https://www.instagram.com/">
                                            <img src={footer_24} alt="icon" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.facebook.com/">
                                            <img src={footer_25} alt="icon" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://x.com/">
                                            <img src={footer_26} alt="icon" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.pinterest.com/">
                                            <img src={footer_27} alt="icon" />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}

export default Footer3
